import React, { useEffect, useState } from 'react';
import dayjs from 'dayjs';
import TimeButton from './TimeButton';

function DateSelector({
	appointmentDate,
	setAgentIdSelected,
	bookedTimeList,
	setSelectTime,
	selectTime,
	handleConfirm,
	setClickedTime,
	clickedTime,
}) {
	const [firstTime, setFirstTime] = useState();
	const [timeRange, setTimeRange] = useState([]);
	const [timeToBeDisabled, setTimeToBeDisabled] = useState();
	const [timeText, setTimeText] = useState();
	const [sameDayTime, setSameDayTime] = useState();
	useEffect(() => {
		var startTime = new Date(appointmentDate);
		startTime.setHours(8, 0, 0);
		setFirstTime(startTime);
	}, [appointmentDate]);

	useEffect(() => {
		var timeRangeArr = [];
		var sameDayTimeArr = [];

		console.log('firstTime', firstTime);

		// The bug is here

		for (var i = 0; i <= 780; i += 15) {
			var add = dayjs(firstTime).add(`${i}`, 'minute');
			console.log('adddd: ' + dayjs(add));
			timeRangeArr.push(dayjs(add));
			console.log('Same day time: ' + add);
			sameDayTimeArr.push(parseInt('' + add));
		}

		console.log('timeRangeArr: ' + timeRangeArr);
		setTimeRange(timeRangeArr);
		setSameDayTime(sameDayTimeArr);
	}, [firstTime]);

	useEffect(() => {
		if (bookedTimeList && appointmentDate && sameDayTime) {
			const filteredArray = sameDayTime.filter((value) =>
				bookedTimeList.includes(value)
			);

			console.log('bookedTimeList: ', bookedTimeList);

			console.log('sameDayTime: ', sameDayTime);

			console.log('filteredArray: ', filteredArray);

			setTimeToBeDisabled(filteredArray);

			console.log('includedd? ' + bookedTimeList.includes(1621080000000));
		}
	}, [bookedTimeList, appointmentDate, sameDayTime]);

	return (
		<div className='date_selector'>
			<h4>{dayjs(appointmentDate).format('dddd, MMMM DD')}</h4>

			{sameDayTime?.map((time) => (
				<TimeButton
					time={time}
					timeToBeDisabled={timeToBeDisabled}
					setClickedTime={setClickedTime}
					clickedTime={clickedTime}
					selectTime={selectTime}
					setSelectTime={setSelectTime}
					setTimeText={setTimeText}
					timeText={timeText}
					handleConfirm={handleConfirm}
					bookedTimeList={bookedTimeList}
				/>
			))}
		</div>
	);
}

export default DateSelector;
